import React from 'react';
import styles from './styles/HeroIndicators.module.css';

/**
 * Componente de indicadores de posición
 * @param {number} total - Total de slides
 * @param {number} current - Índice actual
 * @param {Function} onSelect - Handler al seleccionar un indicador
 */
const HeroIndicators = ({ total, current, onSelect }) => {
  if (total <= 1) return null;

  return (
    <div className={styles.indicators}>
      {Array.from({ length: total }).map((_, index) => (
        <button
          key={index}
          className={`${styles.indicator} ${index === current ? styles.active : ''}`}
          onClick={() => onSelect(index)}
          aria-label={`Ir al slide ${index + 1}`}
          aria-current={index === current ? 'true' : 'false'}
        />
      ))}
    </div>
  );
};

export default HeroIndicators;
